<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false" v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false" v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-6">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 100%" size="small" v-model="item.status">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option label="Hüquqi ekspertə göndərildi" :value="145"></el-option>
              <el-option label="Aktlaşdırma başlanıb" :value="150"></el-option>
              <el-option label="Təsdiqlənməyə göndərilib" :value="151"></el-option>
            </el-select>
            &nbsp;&nbsp;
            <el-button size="small" type="primary"   icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel :fields="cells" :data="data" worksheet="My Worksheet" name="responses">
              <el-button size="small" type="info"><i class="fa-solid fa-download"></i> {{$t('Export')}}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>

      <div class="col-md-8 col-12" style="margin-top: 30px">
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-button type="info" size="mini" @click="getData" circle><i class="fa-solid fa-rotate"></i>
            </el-button>
            &nbsp;&nbsp;&nbsp;
            <el-checkbox @change="getData" v-model="item.myData">{{$t('Mənim_hadisələrim')}}</el-checkbox>
            <el-checkbox @change="getData" v-model="item.noResponsible">{{$t('Məsul_şəxs_təyin_olunmayıb')}} </el-checkbox>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12" style="margin-top: 20px">
        <el-input :placeholder="$t('Axtar')" v-model="search"> </el-input>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <el-table ref="elTable"  v-loading="loading" :data="
          displayData.filter(
            (data) =>
              !search ||
              data.claimNumber
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase()) ||
              data.participants
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase())
          )
        " style="width: 100%">
          >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('İşin_statusu')" width="300">
            <template slot-scope="scope">
              <status-label :type="
                scope.row.statusTypeId === 145
                  ? 'goldenrod'
                  : '' || scope.row.statusTypeId === 146
                    ? 'limeGreen'
                    : '' || scope.row.statusTypeId === 150
                      ? 'mediumBlue'
                      : '' || scope.row.statusTypeId === 151
                        ? 'forestGreen'
                        : '' || scope.row.statusTypeId === 160
                          ? 'success'
                          : ''
              " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>

       <el-table-column :label="$t('İş_#')" sortable prop="dispClaimNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispClaimNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Sığorta növü #" prop="insuranceTypeName" width="120">
          </el-table-column>
          <el-table-column :label="$t('Məsul_şəxs_/_Hüquqi_ekspert')" prop="legalExpertUserName">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_/_Müştəri_xidməti')" prop="clientServiceUserName" width="210">
          </el-table-column>

          <el-table-column sortable :label="$t('Başlama_tarixi_/_Gün_sayı')" prop="statusStartDate" width="240">
          </el-table-column>

          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleCommand(scope.row.id)" style="padding: 0 !important" size="large">
                <i class="fa-solid fa-up-right-from-square"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="this.data.length">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusLabel from "../components/StatusLabel.vue";
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import { GetAllClaimsLegalExpert } from "src/services/common";
export default {
  components: {
    StatusLabel,
  },
  data() {
    return {
      myData: false,
      loading: false,
      startExpert: false,
      data: [],
      search: "",
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },
      uid: this.$store.state.user.id,
      item: {
        startDate: null,
        endDate: null,
        myData: false,
        noResponsible: false,
        startExpert: false,
        status: 0,
      },
      cells: {
        'İşin Statusu': 'statusTypeName',
        'İş #': 'claimNumber',
        'Sığorta növü': 'insuranceTypeName',
        'Məsul şəxs / Hüquqi ekspert': 'techExpertUserName',
        'Məsul şəxs / Müştəri xidməti': 'clientServiceUserName',
        'Başlama tarixi / Gün sayı': 'statusStartDate',
      },
    };
  },
  methods: {
    handleCommand(id) {
      this.handleEdit(id)
    },
    handleEdit(id) {
      let routeData = this.$router.resolve({ path: "claim/" + id });
      window.open(routeData.href, "_blank");
    },
    clickSearch() {
      this.filter.page = 1
      this.getData();
    },
    getData() {
      this.loading = true;
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.commandUserId = this.uid;
      GetAllClaimsLegalExpert(this.item).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
          this.getDisplayData();
        }
      });
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
    getDisplayData() {
      this.displayData = this.data.slice((this.filter.page - 1) * this.filter.pagesize, this.filter.page * this.filter.pagesize)
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getDisplayData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val
      this.getDisplayData();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
